import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";

export default function PaymentPolicy() {
  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>Subscription, Billing, Refund & Service Policy</h1>


      </div>

      {/* TERMS SECTION */}
      <Container style={{ padding: "70px 10px" }}>
        <Row>
          <Col lg={12}>
            <h3 className="mb-3">1. Purpose</h3>
            <p>
              This Policy governs the subscription, billing, payment, renewal, cancellation, refund and support services offered by KVL Matrimony a Platform (https://kvlmatrimony.com).

            </p>
            <h3 className="mt-5 mb-3">2. Membership Plans</h3>
            <p>KVL Matrimony may offer multiple Premium Membership plans.<br />
              The features, validity, benefits and pricing of each plan shall be displayed on the Platform and may be updated from time to time.

            </p>
            <h3 className="mt-5 mb-3">3. Subscription</h3>
            <p>Premium services are available only upon successful payment of the applicable subscription fee.<br />
              Subscriptions are personal, non-transferable and valid only for the selected subscription period.

            </p>

            <h3 className="mt-5 mb-3">4. Billing & Payments</h3>
            <p>
              •	Subscription fees are payable in advance.<br />
              •	All prices are exclusive of applicable taxes unless otherwise stated.<br />
              •	Payments shall be processed through authorized payment service providers.<br />
              •	An payment confirmation and electronic invoice or will be issued upon successful payment.

            </p>

            <h3 className="mt-5 mb-3">5. Renewals</h3>
            <p>
              Membership subscriptions may be renewed before or upon expiry.<br />
              Where auto-renewal is offered and enabled by the member, renewal charges shall be processed in accordance with the selected payment method.<br />
              Members may disable auto-renewal at any time before the renewal date.

            </p>

            <h3 className="mt-5 mb-3">6. Upgrade & Downgrade</h3>
            <p>
              Members may upgrade their subscription at any time by paying the applicable difference in subscription charges.<br />
              Downgrade requests shall become effective upon expiry of the current subscription period unless otherwise specified by choosing an appropriate plan.

            </p>

            <h3 className="mt-5 mb-3">7. Cancellation</h3>
            <p>
              Members may cancel their subscription at any time.<br />
              Cancellation shall discontinue future renewals and shall not affect services already availed during the active subscription period.

            </p>

            <h3 className="mt-5 mb-3">8. Refund Policy</h3>
            <p>Unless expressly stated under a promotional offer or required by applicable law:<br />
              •	Subscription fees are non-refundable.<br />
              •	Partial usage of a subscription does not qualify for a refund.<br />
              •	Failure to use purchased services shall not entitle a member to any refund.<br />
              •	Charges paid to third-party service providers are non-refundable.<br />
              Approved refunds, where applicable, shall be processed through the original payment method.

            </p>
            <h3 className="mt-5 mb-3">9. Failed or Reversed Payments</h3>
            <p>
              KVL Matrimony reserves the right to suspend or restrict Premium services where:<br />
              •	Payment fails.<br />
              •	A payment is reversed or charged back.<br />
              •	Fraudulent payment activity is suspected.<br />
              Access may be restored upon successful verification and settlement of outstanding dues.

            </p>

            <h3 className="mt-5 mb-3">10. Promotional Offers</h3>
            <p>
              From time to time, KVL Matrimony may offer promotional pricing, discounts, coupons or limited-time membership benefits.<br />
              Such offers shall be governed by their respective terms and may be modified or withdrawn without prior notice.

            </p>

            <h3 className="mt-5 mb-3">11. Service Availability</h3>
            <p>
              KVL Matrimony endeavours to provide reliable access to the Platform (https://kvlmatrimony.com).<br />
              Scheduled maintenance, system upgrades, technical issues or events beyond reasonable control may temporarily affect service availability.<br />
              Such interruptions shall not constitute a breach of this Policy.
            </p>

            <h3 className="mt-5 mb-3">12. Customer Support</h3>
            <p>
              Members may contact Customer Support for assistance relating to:<br />
              •	Account access<br />
              •	Subscription<br />
              •	Billing<br />
              •	Payment confirmation<br />
              •	Technical issues<br />
              •	General enquiries<br />
              Support requests may be submitted through the contact channels published on the website.

            </p>

            <h3 className="mt-5 mb-3">13. Policy Changes</h3>
            <p>
              KVL Matrimony reserves the right to revise subscription plans, pricing, features, billing practices and this Policy from time to time.<br />
              Revised terms shall become effective upon publication on the Platform.

            </p>

            <h3 className="mt-5 mb-3">14. Contact</h3>
            <p>
              For subscription, billing or payment-related enquiries, members may contact KVL Matrimony through the official contact details available on the Platform.
            </p>

            <h3 className="mt-5 mb-3">15. User Declaration</h3>
            <p>
              By purchasing or renewing a subscription, you acknowledge that you have read, understood and agree to this Subscription, Billing, Refund & Service Policy.
            </p>



            <p className="mt-5 text-muted">
              <strong>Last Updated:</strong>5th, July 2026
            </p>
          </Col>
        </Row>
      </Container>





      <Footer />
    </>
  );
}
